import { CloseOutlined, SyncOutlined } from '@ant-design/icons';
import { KlaviyoOauthToken } from '@mm/state/model/ConnectionModel';
import classNames from 'classnames';
import React, { MouseEvent } from 'react';
import { PrimaryButton } from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { OauthTokenStatus } from '../OauthTokenStatus/OauthTokenStatus';
import { Help } from './KlaviyoHelpLink';
import styles from './KlaviyoIntegrations.module.css';

type Props = {
  helpLink: string;
  token: KlaviyoOauthToken | undefined;
  connectToken: (tokenId?: number) => void;
  revoke: (tokenId: number) => void;
  controlsDisabled: boolean;
};

export const KlaviyoOauthTokenConnection = (props: Props) => {
  const { token, helpLink, connectToken, revoke, controlsDisabled } = props;

  const revokeToken = (e?: MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    if (token) {
      revoke(token.id);
    }
  };

  const connect = (e?: MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();

    connectToken(token?.id);
  };

  return (
    <div
      className={classNames(styles.box, styles.boxWithHelp, {
        [styles.boxDisabled]: controlsDisabled,
      })}
    >
      <div className={styles.boxContent}>
        <div className={styles.heading}>Connect to Klaviyo Directly</div>
        <div className={styles.connectionButtonsWrapper}>
          {!token ? (
            <PrimaryButton
              // className={styles.primaryButton}
              className={classNames(
                'integrations__header-add-button-secondary',
                'integrations__header-button-no-margin',
              )}
              onClick={e => connect(e)}
            >
              Connect
            </PrimaryButton>
          ) : (
            <>
              <OauthTokenStatus token={token} styles={styles} />
              <PrimaryButton
                className={classNames(
                  'integrations__header-add-button-secondary',
                  'integrations__header-button-no-margin',
                )}
                onClick={e => connect(e)}
                leftIcon={<SyncOutlined />}
              >
                Reconnect
              </PrimaryButton>
              <PrimaryButton
                className={classNames(
                  'integrations__header-add-button-secondary',
                  'integrations__header-button-no-margin',
                )}
                onClick={e => revokeToken(e)}
                leftIcon={<CloseOutlined />}
              >
                Disconnect
              </PrimaryButton>
            </>
          )}
        </div>
      </div>
      <Help link={helpLink} />
    </div>
  );
};
